export class QuestionChainIds {
  public _id?: string;
  public questions: Array<string>;
  public answers: Array<string> = [];
  public tiplist: string;
  public jump?: Array<string>;

  constructor(chain: QuestionChainIds = <QuestionChainIds> {}) {

    if (chain.questions) {
      this.questions = chain.questions.slice(0);
    }

    if (chain.answers) {
      this.answers = chain.answers.slice(0);
    }

    if (chain.tiplist) {
      this.tiplist = chain.tiplist;
    }

    if (chain.jump) {
      this.jump = chain.jump;
    }

  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/question-chain-ids.ts